import {observer} from 'mobx-react';
import * as React from 'react';
import {useContext, useEffect} from 'react';
import {DataGrid} from '@mui/x-data-grid';
import {useBreakpointContext} from '../../../context-providers/BreakpointProvider';
import {getDataGridCommonProps} from '../helpers/data-grid-common-props';
import {getStakePendingWithdrawalsColumns, getStakePendingWithdrawalsColumnsMobile} from '../helpers/columns';
import './StakePendingWithdrawals.scss';
import NereusButton from "../../NereusButton/NereusButton";
import {depositWithdrawalStakeStore} from "../../../services/deposit-withdrawal-stake/deposit-withdrawal-stake.store";
import {ServicesContext} from "../../../context-providers/ServicesProvider";
import {useAccount} from "wagmi";
import {ContractContext} from "../../../context-providers/ContractsProvider";
import {stakeBalanceStore} from "../../../stores/StakeBalanceStore";


const PAGE_SIZE = 100;
const emptyStateText = 'No pending withdrawals';

const StakePendingWithdrawals = observer(() => {

    const { xs } = useBreakpointContext();
    const [paginationEnabled, setPaginationEnabled] = React.useState(depositWithdrawalStakeStore.withdrawalsForRender.length > PAGE_SIZE);
    const { depositWithdrawStakeService } = useContext(ServicesContext);
    const { address: userAddress } = useAccount();
    const { nrsWithdrawalTimelockContract, nrsContract, veNrsContract } = useContext(ContractContext);

    useEffect(() => {
        setPaginationEnabled(depositWithdrawalStakeStore.withdrawalsForRender.length > PAGE_SIZE);
    }, [depositWithdrawalStakeStore.withdrawalsForRender.length]);

    const handleClaim = async (index: number) => {
        try {
            await depositWithdrawStakeService.claim([index])
            if (userAddress) {
                stakeBalanceStore.fetchBalances(nrsContract, veNrsContract, userAddress)
                depositWithdrawalStakeStore.fetchWithdrawals(nrsWithdrawalTimelockContract, userAddress)

            }
        } catch {}
    }
    const handleClaimAll = async () => {
        try {
            const claimableIndices = depositWithdrawalStakeStore.claimableIndices
            await depositWithdrawStakeService.claim(claimableIndices)
            if (userAddress) {
                stakeBalanceStore.fetchBalances(nrsContract, veNrsContract, userAddress)
                depositWithdrawalStakeStore.fetchWithdrawals(nrsWithdrawalTimelockContract, userAddress)

            }
        } catch {}
    }

    return (
        <div className="StakePendingWithdrawals">
            <div className="StakePendingWithdrawals__header card-container text-white flex">
                <div className="StakePendingWithdrawals__header__balances flex flex-grow">
                    <div className="flex-col">
                        <label className="nereus-caption nereus-color-neutral-grey">Requested Withdrawals</label>
                        <div className={`nereus-body-m`}>
                            {depositWithdrawalStakeStore.requestedWithdrawalsAmountDecimal} NRS
                        </div>
                    </div>
                    <div className="flex-col">
                        <label className="nereus-caption nereus-color-neutral-grey">Claimable Withdrawals</label>
                        <div className={`nereus-body-m`}>
                            {depositWithdrawalStakeStore.claimableWithdrawalsAmountDecimal} NRS
                        </div>
                    </div>
                </div>
                {!xs && (
                    <div className="flex">
                        <div>
                            <NereusButton style={{width: 109}} variant="contained"
                                          onClick={() => {
                                              handleClaimAll()
                                          }}
                                          disabled={!depositWithdrawalStakeStore.isClaimAvailable}
                                          className="bg-light-green text-dark-blue w-full">
                                Claim All
                            </NereusButton>
                        </div>
                    </div>
                )}
            </div>
            {xs && (
                <div className="nereus-background-color-bg2 pb-5 pl-5">
                    <NereusButton variant="contained"
                                  style={{minWidth: 129, width: 129}}
                                  onClick={() => {
                                      handleClaimAll()
                                  }}
                                  disabled={!depositWithdrawalStakeStore.isClaimAvailable}
                                  className="bg-light-green text-dark-blue w-full">
                        Claim All
                    </NereusButton>
                </div>
            )}
            <div className="StakePendingWithdrawals__gridWrapper">
                {xs && <DataGrid
                    columnHeaderHeight={72}
                    rowHeight={72}
                    {...getDataGridCommonProps(emptyStateText)}
                    rows={depositWithdrawalStakeStore.withdrawalsForRender}
                    columns={getStakePendingWithdrawalsColumnsMobile({handleClaim})}
                    hideFooter={!paginationEnabled}
                    initialState={{
                        pagination: {
                            paginationModel: {page: 0, pageSize: PAGE_SIZE}
                        },
                        sorting: {
                            sortModel: [{field: 'endTime', sort: 'asc'}]
                        }
                    }}
                />}
                {!xs && <DataGrid
                    {...getDataGridCommonProps(emptyStateText)}
                    rows={depositWithdrawalStakeStore.withdrawalsForRender}
                    columns={getStakePendingWithdrawalsColumns({handleClaim})}
                    hideFooter={!paginationEnabled}
                    initialState={{
                        pagination: {
                            paginationModel: {page: 0, pageSize: PAGE_SIZE}
                        },
                        sorting: {
                            sortModel: [{field: 'endTime', sort: 'asc'}]
                        }
                    }}
                />}
            </div>
        </div>
    );
});

export default StakePendingWithdrawals;
